<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-06-20 08:45:24
 * @LastEditTime : 2025-11-20 14:59:34
 * @LastEditors  : yangxr
 * @Description  : 取样标签打印
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\soiltest\flowcomponent\tagPrint.vue
-->
<template>
  <div style="background: #fff; position: fixed; top: -10000px">
    <div id="print-dom" ref="print-dom" style="background: #fff">
      <div>
      <div v-for="(item, index) in dataArr" :id="'print'+index" :key="index" class="roger"  style="position: relative; font-size: 14px" :style="{ width: '6' + 'cm', height: index == dataArr.length-1 ? '3.8cm': '4.5' + 'cm', paddingTop: index == 0 ? '2mm' : '2mm' }">
        <div style="margin-left: 10px; display: flex; justify-content: space-between">
          <div>
            <div style="display: flex">
              <div style="width: 40px"><span>编号:</span></div>
              <div style="width: 80px; word-break: break-all; display: flex; align-items: center">
                <span style="overflow: hidden; height: 40px">{{ item.code }}</span>
              </div>
            </div>
            <div style="display: flex">
              <div style="width: 40px"><span>龄期:</span></div>
              <div style="width: 80px; word-break: break-all; display: flex; align-items: center">
                <span>{{ item.age }}-{{item.sort}}</span>
              </div>
            </div>
            <div style="display: flex">
              <div style="width: 40px"><span>标号:</span></div>
              <div style="width: 80px; word-break: break-all; display: flex; align-items: center">
                <span>{{ item.product }}</span>
              </div>
            </div>
          </div>
          <div style="width: 100px; display: flex; position: absolute; right: 2px">
            <genQrCode :key="item.code + index" :text="item.code + ',' + item.product + ',' + item.age + ',3,' + item.sort"></genQrCode>
            <!-- <genQrCode style="margin-left: 10px" :text="item.code + ',' + item.product + ',' + item.age + ',3,' + item.sort"></genQrCode> -->
          </div>
        </div>
        <div style="margin-left: 10px">
          <div>
            <div style="display: flex">
              <div style="width: 40px"><span>部位:</span></div>
              <div style="width: 80px; word-break: break-all; display: flex; align-items: center">
                <span style="overflow: hidden; height: 20px">{{ item.pouringPart }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-left: 10px">
          <div>
            <div style="display: flex">
              <div style="width: 40px"><span>工程:</span></div>
              <div style="width: 190px; word-break: break-all; display: flex; align-items: center">
                <span style="overflow: hidden; height: 40px">{{ item.engineeringName }}</span>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-left: 10px">
          <div>
            <div style="display: flex">
              <div style="width: 40px"><span>时间:</span></div>
              <div style="width: 190px; word-break: break-all; display: flex; align-items: center">
                <span>{{ item.field1 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
  </div>
</template>
  <script>
import genQrCode from "./genQrCode.vue";
export default {
  name: "tagPrinter",
  props: ["data"],
  components: { genQrCode },
  data() {
    return {
      canPrint: false,
      cmunit: 37.78,
      confList: [],
      dataConfList: [],
      availableConfList: [],
      canvasSize: {
        x: 0,
        y: 0,
      },
      requestCnt: 0,
      hasImage: false,
      dataArr: [],
    };
  },
  mounted() {
    //打印组件初始化
    this.$pluginName.init({
      host: "http://localhost:17521", // 打印客户端的地址
      token: "icpsPrint", // 与打印客户端相同的 token
    });
  },
  watch: {
    data(val) {
      if (val) {
        this.dataArr = val;
        this.$forceUpdate();
      }
    },
  },
  methods: {
    print() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit("closeDialog");
          // 获取打印机列表
          let print = this.$refs["print-dom"].innerHTML; //获取目标区域
          const hiprintTemplate = new this.$pluginName.PrintTemplate();
          //模板对象获取打印机列表
          const printerList_ = hiprintTemplate.getPrinterList();
          console.log(printerList_);
          if (window.hiwebSocket.opened === false) {
            this.$message.warning("未启动打印服务，使用浏览器打印方式！");
            console.log(this.printerName + "浏览器打印");
            const iframeDom = document.createElement("iframe");
            const attrObj = {
              height: 0,
              width: 0,
              border: 0,
              id: "iframe",
            };
            const styleObj = {
              position: "fixed",
              "z-index": "-999",
              fontSize: "14px",
            };
            Object.entries(attrObj).forEach(([key, value]) => iframeDom.setAttribute(key, value));
            Object.entries(styleObj).forEach(([key, value]) => {
              iframeDom.style[key] = value;
            });
            document.body.appendChild(iframeDom);
            const iframeDocs = iframeDom.contentWindow.document;
            iframeDocs.body.style.margin = "0px";
            iframeDocs.write(print);
            iframeDocs.write('<style media="print">@page {size: auto;  margin: 0mm; }</style>');
            //     iframeDocs.write(
            //       // 实现分页主要代码
            //       `<style>
            //   .roger {
            //     page-break-before:always !important;
            //     page-break-after:always !important;
            //     font-size:14px;
            //   }
            // </style>`
            //     );
            window.setTimeout(
              function () {
                iframeDom.contentWindow.print();
                document.body.removeChild(iframeDom);
              },
              this.hasImage ? 5000 : 1500
            );
          } else {
            let printIndex = printerList_.findIndex(item => item.name == this.printerName);
            let printerName = printIndex == -1 ? "" : this.printerName;
            console.log(printerName);
            console.log(print);
            hiprintTemplate.printByHtml2(print, {
              printer: printerName, // 打印机名称，不填则默认打印机
              title: "任务队列中名称",
              // styleHandler: () => {
              //   let css = `<style>
              //   .roger {
              //     page-break-before:always !important;
              //     page-break-after:always !important;
              //     font-size:14px;
              //   }
              // </style><style media="print">@page {size: auto;  margin: 0mm; }</style>`;
              //   return css;
              // },
            }); //直接打印，需要安装客户端 下面会提到客户端的安装
          }
        }, 700);
      });
    },
  },
};
</script>